import { Suggestion, SuggestionKind } from 'owa-search-service';

export default function orderSuggestions(suggestions: Suggestion[]): Suggestion[] {
    /**
     * We really shouldn't be re-ordering suggestions returned from the service.
     * The most we should do is ensure that client-side suggestions (i.e. category)
     * are last in the list.
     */
    const serverSuggestions = suggestions.filter((suggestion: Suggestion) => {
        return suggestion.kind !== SuggestionKind.Category;
    });

    const clientSuggestions = suggestions.filter((suggestion: Suggestion) => {
        return suggestion.kind === SuggestionKind.Category;
    });

    return [].concat(serverSuggestions, clientSuggestions);
}
